import React from 'react'

const ServicesIcon = ({ className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none"
      className={`transition-colors duration-200 ${className}`}
      {...props}
    >
      <path 
        d="M14 6H10C8.644 6 7.532 6 6.61 6.054C4.965 6.151 3.922 6.421 3.172 7.172C2 8.343 2 10.229 2 14C2 17.771 2 19.657 3.172 20.828C4.344 21.999 6.229 22 10 22H14C17.771 22 19.657 22 20.828 20.828C21.999 19.656 22 17.771 22 14C22 10.229 22 8.343 20.828 7.172C20.078 6.422 19.035 6.152 17.391 6.054C16.468 6 15.356 6 14 6Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <path 
        d="M6.61035 6.054C7.43335 6.034 8.16035 5.454 8.44035 4.68L8.47535 4.577L8.50035 4.5C8.54235 4.373 8.56435 4.31 8.58635 4.254C8.72761 3.90281 8.96564 3.59892 9.27276 3.37765C9.57989 3.15638 9.94351 3.02681 10.3214 3.004C10.3804 3 10.4484 3 10.5804 3H13.4184C13.5514 3 13.6184 3 13.6784 3.004C14.0562 3.02681 14.4198 3.15638 14.7269 3.37765C15.0341 3.59892 15.2721 3.90281 15.4134 4.254C15.4364 4.31 15.4574 4.374 15.4994 4.5L15.5254 4.577C15.5434 4.63 15.5514 4.657 15.5604 4.68C15.8404 5.455 16.5674 6.034 17.3904 6.054" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <path 
        d="M21.6619 8.71997C18.6519 10.676 17.1469 11.654 15.5609 12.147C13.2419 12.8675 10.7589 12.8675 8.43989 12.147C6.85289 11.654 5.34789 10.677 2.33789 8.71997M7.99989 11V13M15.9999 11V13" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  )
}

export default ServicesIcon
